/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 商品分类
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<dictionary.CommodityTypeDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/dictionary/commodity/types`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
